// 3rd party imports
import * as React from 'react';
import { Route } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { inject, observer } from 'mobx-react';

// bernie
import { ContextStore } from 'bernie-plugin-mobx';

// mobx
import { UserAuthStore } from 'stores';

// components
import { SecureRoute } from './secure-route';
import { modifyLocaleParam } from '../../util/locale-param-transformer';

interface WithSecurityProps extends RouteComponentProps {
  context?: ContextStore;
  userAuth?: UserAuthStore;
}

export const withSecurity = (
  insideComponent,
  path,
  secure = true,
  withCaptcha = false,
  withAuthorization = false,
  unAuthorizedPath = '/signin',
) => {
  @inject('userAuth', 'context')
  @observer
  // TODO: convert to FC
  class ComponentWithSecurity extends React.Component<WithSecurityProps> {
    constructor(props) {
      super(props);
      this.props.userAuth.hydrateHistory(this.props.history);
    }

    public render() {
      const locale = modifyLocaleParam(this.props.context.locale);
      const componentPath = path.replace(':localeName', locale);
      const redirectPath = unAuthorizedPath.replace(':localeName', locale);

      let route;

      if (secure) {
        route = (
          <SecureRoute
            requireAuthorization={withAuthorization}
            path={componentPath}
            component={insideComponent}
            redirectPath={redirectPath}
          />
        );
      } else {
        route = <Route path={componentPath} component={insideComponent} />;
      }

      return <>{route}</>;
    }
  }

  return ComponentWithSecurity;
};
